import { render, staticRenderFns } from "./knowledgeList.vue?vue&type=template&id=5d73f23b&scoped=true"
import script from "./knowledgeList.vue?vue&type=script&lang=js"
export * from "./knowledgeList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeList.vue?vue&type=style&index=0&id=5d73f23b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73f23b",
  null
  
)

export default component.exports